import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { CompanyWrite } from "./useCreateOrganization";

type UpsertOrganizationSupplier = {
    company: CompanyWrite;
    organizationId: number;
};

export const useUpsertOrganizationSupplier = () => {
    return useMutation({
        mutationFn: async (options: UpsertOrganizationSupplier) => {
            const { company, organizationId } = options;
            const endpoint = `/api/organizations/${organizationId}/suppliers`;

            return company.id === undefined ?
                    await loggedInApiCall.post(endpoint, company)
                :   await loggedInApiCall.put(`${endpoint}/${company.id}`, company);
        },
    });
};
